import React from 'react';

const SERVICES = [
  {
    title: 'Bookkeeping services',
    text: 'Sales and purchase ledgers kept up to date every month in Zoho Books, QuickBooks, Xero or Tally.',
  },
  {
    title: 'Monthly accounting',
    text: 'Profit and loss, balance sheet and cash position in your inbox by the 10th.',
  },
  {
    title: 'Bank reconciliation',
    text: 'Every bank and card line matched, so your records agree with your statements.',
  },
  {
    id: 'vat-ready-records',
    title: 'VAT-ready records',
    text: 'Input and output VAT tracked monthly, so your quarter-end position is already known.',
  },
  {
    title: 'Outsourced accounting',
    text: 'Your finance function run by an accounting firm in Dubai, without hiring in-house.',
  },
  {
    title: 'Backlog accounting',
    text: 'Missed months rebuilt and reconciled, then handed into a clean monthly routine.',
  },
];

const AREAS = [
  'Business Bay',
  'JLT',
  'DMCC',
  'Deira',
  'Bur Dubai',
  'Al Quoz',
  'Dubai Silicon Oasis',
  'JAFZA',
  'Dubai Internet City',
  'Sharjah',
  'Abu Dhabi',
];

const ServicesSection = () => (
  <section className="bk-services" id="services" data-screen-label="Services">
    <div className="bk-container">
      <h2 className="bk-h2 bk-h2--xl bk-services-title">
        Bookkeeping and accounting services in Dubai, <span className="bk-accent">under one roof</span>
      </h2>

      <div className="bk-services-grid">
        {SERVICES.map((s, i) => (
          <article className="bk-service-card" key={s.title} id={s.id}>
            <span className="bk-num">{String(i + 1).padStart(2, '0')}</span>
            <h3 className="bk-service-title">{s.title}</h3>
            <p className="bk-service-text">{s.text}</p>
          </article>
        ))}
      </div>

      <div className="bk-jurisdictions">
        <span className="bk-jurisdictions-label">Serving companies across Dubai:</span>
        <ul>
          {AREAS.map((area) => (
            <li key={area}>{area}</li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default ServicesSection;
